<template>
    <div class="app-container">
        <div class="filter-container" style='marginBottom:10px;'>
            
            <el-input v-model="listQuery.title" placeholder="故障简述" size="mini" style="width: 100px;margin:0 5px" class="filter-item" @keyup.enter.native="handleFilter"/>
            
            <el-select v-model="listQuery.level" placeholder="级别" collapse-tags multiple clearable style="width: 120px;margin:0 5px" class="filter-item" size="mini">
                <el-option v-for="item in level_list" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            
            <el-select v-model="listQuery.sla" placeholder="SLA" clearable style="width: 70px;margin:0 5px" class="filter-item" size="mini">
                <el-option v-for="item in sla" :key="item.value" :label="item.label" :value="item.value" size="mini"/>
            </el-select>

            <el-date-picker
             v-model="start_time_range"
             type="datetimerange"
             start-placeholder="开始时间"
             end-placeholder='结束时间'
             size="mini"
             value-format="yyyy-MM-dd HH:mm:ss"
             class="filter-item"
             style="display: inline-flex; width: 180px;margin:0 5px"
             @keyup.enter.native="handleFilter"/>
            
            <el-select v-model="listQuery.status" placeholder="故障状态" collapse-tags multiple clearable style="width: 210px;margin:0 5px" class="filter-item" size="mini">
                <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>

            <el-select v-model="listQuery.category_1" placeholder="产品线" clearable style="width: 120px;margin:0 5px" class="filter-item" @clear="reloadCategory2" @change="reloadCategory2" size="mini">
                <el-option v-for="item in category1_list" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>

            <el-select v-model="listQuery.category_2" placeholder="项目名称" multiple clearable style="width: 150px;margin:0 5px" class="filter-item" size="mini">
                <el-option v-for="item in category2_list" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>

            <el-select v-model="listQuery.department" placeholder="责任部门" collapse-tags multiple clearable style="width: 140px;margin:0 5px" class="filter-item" size="mini">
                <el-option v-for="item in departments" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>

            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter" style='margin:0 5px' size="mini" >搜索</el-button>
            
            <el-input v-model="filename" placeholder="请输入文件名(默认excel-list)" style="width:240px;margin:0 5px" prefix-icon="el-icon-document" size="mini"/>
            
            <el-button :loading="downloadLoading" style="margin-bottom:20px" type="primary" icon="document" @click="handleDownload" size="mini">导出已选择项</el-button>
        </div>

        <el-table size="mini" v-loading="listLoading" ref="multipleTable" :data="list" element-loading-text="Loading" style='margin:0 5px'  border @sort-change="sortChange" @selection-change="handleSelectionChange">
            
            <el-table-column type="selection" align="center"/>
            
            <el-table-column align="center" label="序号" width="60" prop="id" sortable="custom" />
            
            <el-table-column label="项目" width="200" align="center" prop="category" />
            
            <el-table-column label="故障简述" min-width="200" align="center">
                <template slot-scope="scope">
                    <el-button type='text' class="link-type" @click="handleUpdate(scope.row.id,0)" >{{ scope.row.title }}</el-button>
                </template>
            </el-table-column>
            
            <el-table-column label="级别" width="80" align="center" prop='level' />
            
            <el-table-column label="出具故障报告" width="80" align="center" prop='report' />
            
            <el-table-column label="影响SLA" width="80" align="center" prop='sla' />
            
            <el-table-column label="开始时间" width="160" align="center" prop='start_time' />
            
            <el-table-column label="关闭时间" width="160" align="center" prop='deadline' />
            
            <el-table-column label="故障时长" width="100" align="center" prop='duration' />
            
            <el-table-column label="故障状态" width="120" align="center" prop='flow_status' />
            
            <el-table-column label="责任部门" width="140" align="center" prop='department' />
            
            <el-table-column label="操作" width="180" align="center" fixed='right'>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.flow_status=='故障等待REVIEW'" size="mini" type="primary" @click="handleUpdate(scope.row.id,1)">review</el-button>
                    <el-button v-else size="mini" type="primary" disabled>review</el-button>
                    <el-button size="mini" type="danger" v-w-role=" 'SJGL0002'" @click='cancel(scope.row.id)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page_num" :limit.sync="listQuery.page_size" @pagination="fetchData"/>
    
    </div>

</template>

<script>
import { statusList, getList, eventDelete } from "../../../services/fault/table";
import Pagination from "../../../components/Pagination";
import { levelList, categoryList, categoryChildren } from "../../../services/fault/new";
import { departmentList } from "../../../services/fault/edit";

export default {
  components: { Pagination },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      multipleSelection: [],
      downloadLoading: false,
      filename: "",
      listQuery: {
        page_size: 20,
        page_num: 1,
        level: [],
        status: [],
        category_1: "",
        category_2: [],
        department: [],
        sort: "desc"
      },
      level_list: [],
      sla: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      departments: [],
      status_list: [],
      start_time_range: "",
      category1_list: [],
      category2_list: [],
      params: {}
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    levelList().then(response => {
      this.level_list = response.level_data.map(item => {
        return { value: item.name, label: item.name };
      });
    });
    departmentList().then(response => {
      this.departments = response.department_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    statusList().then(response => {
      this.status_list = response.flow_status_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    categoryList({ level: 1 }).then(response => {
      this.category1_list = response.category_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
  },
  methods: {
    reloadCategory2() {
      this.listQuery.category_2 = [];
      categoryChildren({ category_id: this.listQuery.category_1 }).then(
        response => {
          this.category2_list = response.category_data.map(item => {
            return { value: item.id, label: item.name };
          });
        }
      );
    },
    fetchData(context) {
      this.listLoading = true;
      this.params = {
        ...this.listQuery,
        page_num: context ? context.page : this.listQuery.page_num,
        page_size: context ? context.limit : this.listQuery.page_size
      };
      this.params.level = this.listQuery.level.join(",");
      this.params.status = this.listQuery.status.join(",");
      this.params.category_2 = this.listQuery.category_2.join(",");
      this.params.department = this.listQuery.department.join(",");
      getList(this.params).then(response => {
        this.list = response.event_data;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDownload() {
      if (this.multipleSelection.length) {
        this.downloadLoading = true;
        import("../../../core/utils/Export2Excel").then(excel => {
          const tHeader = [
            "故障简述",
            "级别",
            "是否出具故障报告",
            "是否影响SLA",
            "开始时间",
            "关闭时间",
            "故障时长",
            "故障状态",
            "项目",
            "责任部门"
          ];
          const filterVal = [
            "title",
            "level",
            "sla",
            "report",
            "start_time",
            "deadline",
            "duration",
            "flow_status",
            "category",
            "department"
          ];
          const list = this.multipleSelection;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename
          });
          this.$refs.multipleTable.clearSelection();
          this.downloadLoading = false;
        });
      } else {
        this.$message({
          message: "请选择至少一项",
          type: "warning"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleUpdate(event_id, review) {
      this.$router.push({
        path: "/fault/fault_edit",
        query: {
          event_id: event_id,
          review: review
        }
      });
    },
    sortChange(data) {
      const { prop, order } = data;
      if (prop === "id") {
        this.sortByID(order);
      }
    },
    sortByID(order) {
      if (order === "ascending") {
        this.listQuery.sort = "asc";
      } else {
        this.listQuery.sort = "desc";
      }
      this.handleFilter();
    },
    handleFilter() {
      this.listQuery.page_num = 1;
      this.listQuery.start_time_1 = this.start_time_range[0];
      this.listQuery.start_time_2 = this.start_time_range[1];
      this.fetchData();
    },
    cancel(id) {
        this.$confirm('此操作将永久删除该故障, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                eventDelete({ id }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }, err => {
                    this.$message.error(err.message)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
        });
    }
  }
};
</script>
